module.exports = __webpack_public_path__ + "img/world-map.8e35cf36.jpg";